import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import { FormInput } from 'components/shared/Forms/ReduxForm'
import SortableCell from 'components/shared/Helpers/SortableCell'
import SortableHeaderCell from 'components/shared/Helpers/SortableHeaderCell'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames, sort } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { Field, formValues, initialize, reduxForm } from 'redux-form'
import { deleteDiscount } from 'redux/discounts'
import { confirmationModal } from 'redux/navigation'
import { Button, FormDropdown, Icon, Segment, Table } from 'semantic-ui-react'
import { CHF } from '../../../lib/utilities'

const i18nkey = 'admin.discounts.browser.'

const mapStateToProps = (state, ownProps) => {
  const { discounts } = state.discounts
  const { users } = state.userAdmin
  return { discounts, users }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      initialize,
      push,
      confirmationModal,
      deleteDiscount,
    },
    dispatch
  )
}

class DiscountBrowser extends React.Component {
  state = {
    sortCol: 'valid_until',
    direction: 'descending',
  }

  sortBy(sortCol) {
    const { direction } = this.state

    this.setState({
      sortCol: sortCol,
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  getDiscountList() {
    const { sortCol, direction } = this.state
    const { discounts, push, confirmationModal, deleteDiscount } = this.props //redux
    const { filterText } = this.props // formValues
    const discount_id = +this.props.match.params.discount_id
    let filteredDiscounts = discounts.filter((d) => !d.user_id || d.user_id === 1)
    if (filterText)
      filteredDiscounts = filteredDiscounts.filter((discount) =>
        discount.code.toLowerCase().includes(filterText.toLowerCase())
      )

    let sortedDiscounts = filteredDiscounts
    if (sortCol) {
      // presort by id to get consistent sorts for same values of sortCol
      sortedDiscounts = sortedDiscounts.sort((a, b) => sort(a, b, 'id'))
      sortedDiscounts = sortedDiscounts.sort((a, b) => sort(a, b, sortCol))
      if (direction !== 'ascending') sortedDiscounts = sortedDiscounts.reverse()
    }

    return sortedDiscounts.map((discount, index) => (
      <Table.Row
        key={index}
        active={discount_id === discount.id}
        className={classNames([
          discount_id && !(discount_id === discount.id) && 'unobtrusive',
        ])}
        onClick={(event) => {
          event.preventDefault()
          push(`${config.nodes.discount}${discount.id}`)
        }}>
        <SortableCell
          sort={sortCol}
          name="kind"
          text={
            (Array.isArray(discount.product_ids) &&
            discount.product_ids.length > 0
              ? I18n.t(i18nkey + 'product') + ' '
              : '') + I18n.t(i18nkey + discount.kind)
          }
        />
        <SortableCell
          sort={sortCol}
          name="value"
          text={`${
            discount.kind !== 'percent'
              ? CHF(+discount.value)
              : discount.value
          }${
            discount.kind === 'percent' || discount.kind === 'product'
              ? '%'
              : ''
          }`}
        />
        <SortableCell
          sort={sortCol}
          name="code"
          highlight={filterText}
          text={discount.name}
        />
        <SortableCell
          sort={sortCol}
          name="valid_from"
          textAlign="right"
          children={new Date(discount.valid_from).toLocaleDateString(
            'de-CH',
            config.format.date
          )}
        />
        <SortableCell
          sort={sortCol}
          name="valid_until"
          textAlign="right"
          children={new Date(discount.valid_until).toLocaleDateString(
            'de-CH',
            config.format.date
          )}
        />
        <Table.Cell textAlign="right">
          <Icon
            onClick={() =>
              confirmationModal({
                icon: config.icons.modalDelete,
                negative: true,
                title: I18n.t(i18nkey + 'delete_title'),
                button: I18n.t(i18nkey + 'confirm_delete'),
                confirm: () => deleteDiscount(discount.id),
              })
            }
            {...config.icons.delete}
            link
          />
        </Table.Cell>
      </Table.Row>
    ))
  }

  render() {
    const dark = config.theme.dark
    const { sortCol, direction } = this.state
    const { push } = this.props
    return (
      <div
        className={classNames([
          'discountBrowser',
          'form',
          'ui',
          dark && 'inverted',
        ])}>
        <ComponentHeader
          title={I18n.t(i18nkey + 'title')}
          customActions={[
            <Field
              component={FormInput}
              icon="search"
              placeholder={I18n.t('global.filter')}
              name="filterText"
            />,
            <FormDropdown
              options={[
                {
                  key: 1,
                  text: I18n.t(I18n.t(i18nkey + 'discount')),
                  value: 'discount',
                },
                {
                  key: 2,
                  text: I18n.t(I18n.t(i18nkey + 'credit')),
                  value: 'credit',
                },
              ]}
              name="new_row"
              trigger={
                <Button
                  primary
                  labelPosition="left"
                  content={I18n.t(i18nkey + 'new')}
                  icon="plus"
                />
              }
              icon={false}
              pointing="right"
              onChange={(e,c) => push(`${config.nodes.discount}+${c.value}`)}
            />,
          ]}
        />

        <Segment
          attached
          className={classNames([
            'payload',
            'scroll',
            'small',
            dark && 'inverted',
          ])}>
          <Table
            compact
            size="small"
            selectable
            sortable
            singleLine
            basic="very"
            className="spaced">
            <Table.Header>
              <Table.Row>
                <SortableHeaderCell
                  collapsing
                  name="type"
                  title={I18n.t(i18nkey + 'type')}
                  onClick={() => this.sortBy('kind')}
                  sortCol={sortCol}
                  direction={direction}
                />
                <SortableHeaderCell
                  name="value"
                  title={I18n.t(i18nkey + 'value')}
                  onClick={() => this.sortBy('value')}
                  sortCol={sortCol}
                  direction={direction}
                />
                <SortableHeaderCell
                  collapsing
                  name="code"
                  title={I18n.t(i18nkey + 'code_name')}
                  onClick={() => this.sortBy('code')}
                  sortCol={sortCol}
                  direction={direction}
                />
                <SortableHeaderCell
                  collapsing
                  name="valid_from"
                  title={I18n.t(i18nkey + 'valid_from')}
                  onClick={() => this.sortBy('valid_from')}
                  sortCol={sortCol}
                  direction={direction}
                />
                <SortableHeaderCell
                  collapsing
                  name="valid_until"
                  title={I18n.t(i18nkey + 'valid_until')}
                  onClick={() => this.sortBy('valid_until')}
                  sortCol={sortCol}
                  direction={direction}
                />
                <Table.HeaderCell collapsing />
              </Table.Row>
            </Table.Header>
            <Table.Body children={this.getDiscountList()} />
          </Table>
        </Segment>
      </div>
    )
  }
}

DiscountBrowser = connect(mapStateToProps, mapDispatchToProps)(DiscountBrowser)
DiscountBrowser = formValues('filterText')(DiscountBrowser)
DiscountBrowser = reduxForm({
  form: 'discounts',
  initialValues: {
    filterText: '',
  },
})(DiscountBrowser)
export default withRouter(DiscountBrowser)



// WEBPACK FOOTER //
// ./src/components/admin/Discounts/DiscountBrowser.jsx